export const openFaq = () => {
  window.open("https://www.nutricoach.co.uk/#faq", "_blank", "noopener,noreferrer");
};

export const openContactEmail = (subject: string) => {
  window.open(`mailto:hello@nutricoach.co.uk?subject=${encodeURIComponent(subject)}`, "_self");
};
